import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { ORGAO_EMISSOR_ATO_LEGAL_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    ORGAO_EMISSOR_ATO_LEGAL_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    ORGAO_EMISSOR_ATO_LEGAL_ENDPOINT,
    id
  ]);
}
